<script setup lang="ts">
import ButtonFlatStyle from '../atoms/styles/ButtonFlatStyle.vue';
import { computed } from 'vue';
import LineIcon from '~theme/assets/icons/fill/line.svg?component';
import PromptUserToLoginWithDefaultBrowser from '~theme/components/templates/LoginTemplate/PromptUserToLoginWithDefaultBrowser.vue';

const { userAgent } = useUserAgent();

const props = withDefaults(
  defineProps<{
    title?: string;
    disabled?: boolean;
  }>(),
  { title: 'LINEではじめる', disabled: false }
);

const emit = defineEmits<{ (e: 'onClickLineLogin'): void }>();

const {
  PromptUserToLoginWithDefaultBrowserModal,
  openPromptUserToLoginWithDefaultBrowserModal,
} = useModalNamed('promptUserToLoginWithDefaultBrowser');

const isUserAgentInstagram = computed(() => {
  return userAgent.value.browser.name === 'Instagram';
});

const elementTag = computed(() => (props.disabled ? 'div' : 'button'));

const onLineLoginClick = () => {
  if (isUserAgentInstagram.value) {
    openPromptUserToLoginWithDefaultBrowserModal();
    return;
  }
  emit('onClickLineLogin');
};
</script>

<template>
  <ButtonFlatStyle variant="line" size="large" :disabled="disabled">
    <component
      :is="elementTag"
      :class="$style.button"
      v-bind="$attrs"
      @click="onLineLoginClick"
    >
      <LineIcon :class="$style.button__logo" />
      <span>{{ title }}</span>
      <PromptUserToLoginWithDefaultBrowserModal closeable>
        <PromptUserToLoginWithDefaultBrowser />
      </PromptUserToLoginWithDefaultBrowserModal>
    </component>
  </ButtonFlatStyle>
</template>

<style lang="scss" module>
.button {
  &__logo {
    margin-right: 8px;
    width: 24px;
  }
}
</style>
